import React, { Component } from 'react'
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

// Forms search (pages/forms/index.js). The page header holds "Add form"; this
// bar is just the name search, applied on Search or Enter.
@inject('viewStore') @observer
class Form extends Component {

  @action
  search() {
    const { viewStore } = this.props;
    viewStore.formSearch.page = 1;
    viewStore.forms();
  }

  @action
  onSearchTermChange(event) {
    const { viewStore } = this.props;
    viewStore.formSearch = { ...viewStore.formSearch, term: event.target.value };
  }

  onEnter(event) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  render() {
    const { term } = this.props.viewStore.formSearch;
    return (
      <SearchFiltersToolbar searchButton={<SearchFiltersSearchButton onClick={this.search.bind(this)} />}>
        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="Search by form name"
          aria-label="Search forms by name"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    );
  }
}

export default Form;
